require([],
function () {
    
    var navigation = {
        init: function () {
            this.actions();
        },
        actions: function () {
            this.animatemenu();
            this.animatesubmenu();
            this.accordionfooter();
            this.heroslider();
            this.menumobile();
            this.mainmenu();
            this.dynamicvideo();
        },
        // MAIN MENU
        mainmenu: function () {
            $(".main-menu .level-1 > .menu-item").on("click", function (e) {
                // click for opening the menu should only work in mobile view, not in desktop view
                if ($(this).parent().hasClass("mobile-view")) {
                    $(this).find(".menu-dropdown").fadeToggle(150);
                    e.preventDefault();
                }
            });
        },
        // MENU MOBILE
        menumobile: function () {
            $(".main-menu .menu-mobile").on("click", function (e) {
                // Hamburger menu clicked. Set class that will display mobile menu, and also serve as an indicator for hover and click actions.
                $(".main-menu .level-1").toggleClass('mobile-view');
                e.preventDefault();
            });
        },
        // ANIMATE MOBILE SLIDE IN
        animatemenu: function () {
            $('.menu5').on('click', function () {
                $(this).toggleClass('open');
                $('.mob-nav').toggleClass('pc-hide');
                $('#header').toggleClass('fixed');
                $('html').toggleClass('static');
                $('body').toggleClass('static');
            });
        },
        animatesubmenu: function () {
            $('.open-sub').on('click', function (e) {
                if($(this).children(':first-child').attr("class")=="sub-empty"){
                }
                else {
                    if($(this).parent().hasClass('sub-2') && $(this).parent().children(':first-child').attr("class")=="sub-empty"){
                        $('#mobmenu').toggleClass('shift'); 
                    } 
                    $(this).parent().toggleClass('open');
                    $(this).parent().parent().toggleClass('show-l-1');
                    $('.mob-nav').scrollTop(0);
                }
            });
            $('.sub-2').on('click', function (e) {
                if($(this).children(':first-child').attr("class")=="sub-empty"){
    
                }
                else {
                    $(this).parent().toggleClass('open');
                    $('#mobmenu').toggleClass('shift');
                }
            });
            $('.sub-2 a').on('click', function (e) {
                $('.mob-nav').addClass('pc-hide');
                $('.menu5').removeClass('open');
                $('#content').addClass('mobile-loading');
                $('#content').append('<div class="spinner"></div>');
            });
            $('.sub-3 a').on('click', function (e) {
                $('.mob-nav').addClass('pc-hide');
                $('.menu5').removeClass('open');
                $('#content').addClass('mobile-loading');
                $('#content').append('<div class="spinner"></div>');
            });
        },
        accordionfooter: function () {
            $('.footer-bar .icon').on('click', function (e) {
                //e.preventDefault();
                if ($(this).hasClass('open')) {
                    $(".open").each(function( index ) {
                        $(this).removeClass('open');
                    });    
                }
                else {
                    $(".open").each(function( index ) {
                        $(this).removeClass('open');
                    });   
                    $(this).prevAll().addClass('open');          
                    $(this).next().addClass('open');        
                }
            });
        },
        heroslider: function () {
            if ($(".hero.slider").length) {
                $(".hero.slider").slick({
                    responsive: [
                        {
                            breakpoint: 768,
                            settings:
                            {
                                dots: true,
                                arrows: false
                            }
                        }
                    ]
                });
            }
        },
        dynamicvideo: function () {
            function YouTubeGetID(url){
              var ID = '';
              url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
              if(url[2] !== undefined) {
                ID = url[2].split(/[^0-9a-z_\-]/i);
                ID = ID[0];
              }
              else {
                ID = url;
              }
                return ID;
            }
            $('.video-embed').each(function(){
                var y = $(this).attr('data-src');
                var z = $(this).attr('data-background');
                if (!y) return;
                var v = YouTubeGetID(y);
                if (z) {
                    $(this).css('background-image', 'url(' + z + ')');
                } else {
                    $(this).css('background-image', 'url(https://img.youtube.com/vi/' + v + '/hqdefault.jpg)');
                }
            });
            $('.video_wrapper .icon-play, .video_wrapper .play-icon, .video_wrapper .icon-play-video, .video_wrapper .cp-play-video').on('click', function () {                
                var b = $(this).next().attr('data-src');
                $(this).next().attr('src', b + '?autoplay=1');
                $(this).remove();
            });           
        }
    }

    navigation.init();
});

define("MainMenu/main", function(){});

